module.exports = __webpack_public_path__ + "static/media/ope_jenni_922x1229.8deb3ca4.jpg";